// import axios from './http';
import axios from 'axios'
import Vue from 'vue';
import userService from '@/services/user'

export default {
    state: {
        getUrl() {
            const instance = axios.create({
                baseURL: Vue.config['url']
            });
            //instance.defaults.headers.common['Authorization'] = AUTH_TOKEN;
            instance.defaults.headers.common['x-auth-token'] = localStorage.getItem('token');
            instance.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded'
            return instance
        }
    },
    getCustomer(datas) {
        var keyword = (datas && datas.keyword) ? datas.keyword : '';
        var limit = (datas && datas.limit) ? datas.limit : '';
        var headoffice = (datas && datas.headoffice) ? datas.headoffice : '';
        var data_delete = (datas && datas.data_delete) ? datas.data_delete : '';
        var all = (datas && datas.all) ? true : false;
        if (all === false) {
            return axios.get('/v1/bookprice/customer?keyword=' + keyword + '&limit=' + limit + '&headoffice=' + headoffice + '&data_delete=' + data_delete)
                .then(function (response) {
                    return Promise.resolve(response);
                })
                .catch(function (error) {
                    return Promise.reject(error);
                });
        } else {
            return axios.get('/v1/bookprice/customer?keyword=' + keyword + '&limit=' + limit + '&headoffice=' + headoffice + '&data_delete=' + data_delete + '&all=' + all)
                .then(function (response) {
                    return Promise.resolve(response);
                })
                .catch(function (error) {
                    return Promise.reject(error);
                });
        }
    },
    getListDataTable(datas) {
        var type = (datas && datas.type) ? datas.type : '';
        var keyword = (datas && datas.keyword) ? datas.keyword : '';
        var tab = (datas && datas.tab) ? datas.tab : '';
        var emp_code = (datas && datas.emp_code) ? datas.emp_code : '';
        var booktype = (datas && datas.booktype) ? datas.booktype : '';
        return axios.get('/v1/bookprice/groupbook?search=' + type + '&keyword=' + keyword + '&tab=' + tab + '&emp_code=' + emp_code + '&booktype=' + booktype)
            .then(function (response) {
                return Promise.resolve(response.data);
            })
            .catch(function (error) {
                return Promise.reject(error);
            });
    },
    getGroupbookDetail(datas) {
        var id = (datas && datas.id) ? datas.id : '';
        var tab = (datas && datas.tab) ? datas.tab : '';
        return axios.get('/v1/bookprice/groupbook/' + id + '?tab=' + tab)
            .then(function (response) {
                return Promise.resolve(response.data);
            })
            .catch(function (error) {
                return Promise.reject(error);
            });
    },
    getHeadOffice() {
        return axios.get('/v1/bookprice/headoffice')
            .then(function (response) {
                return Promise.resolve(response.data);
            })
            .catch(function (error) {
                return Promise.reject(error);
            });
    },
    saveGroupbook(datas) {
        return axios.post('/v1/bookprice/groupbook', datas)
            .then(function (response) {
                return Promise.resolve(response);
            })
            .catch(function (error) {
                return Promise.reject(error);
            });
    },
    getNumberGroupbook(datas) {
        var tab = (datas && datas.tab) ? datas.tab : '';
        var emp_code = (datas && datas.emp_code) ? datas.emp_code : '';
        return axios.get('/v1/bookprice/number-groupbook?tab=' + tab + '&emp_code=' + emp_code)
            .then(function (response) {
                return Promise.resolve(response.data);
            })
            .catch(function (error) {
                return Promise.reject(error);
            });
    },
    getListRequestPrice(datas) {
        var bookcode = (datas && datas.bookcode) ? datas.bookcode : '';
        var id = (datas && datas.id) ? datas.id : '';
        var emp_code = (datas && datas.emp_code) ? datas.emp_code : '';
        return axios.get('/v1/bookprice/bookprice?bookcode=' + bookcode + '&id=' + id + '&emp_code=' + emp_code)
            .then(function (response) {
                return Promise.resolve(response.data);
            })
            .catch(function (error) {
                return Promise.reject(error);
            });
    },
    makeDataTableMessage() {
        var datas = [];
        for (var i = 0; i < 30; i++) {
            datas.push({
                title: "Request Price",
                desc: "Item code : 000219, 000233, 000691, 000714, 000721, 000738, 000745, 000752, 000769, 000776, 001001, 001018, 000219, 000233, 000691, 000714, 000721, 000738, 000745, 000752, 000769, 000776, 001001, 001018",
                u_date: "18-02-2018 12:00:37"
            });
        }
        return Promise.resolve(datas);
    },
    makeDataTableChangePrice() {
        var datas = [];
        for (var i = 0; i < 20; i++) {
            var num = (i < 10) ? "0" + i : i;
            datas.push({
                code: "0002" + num,
                title_th: "ครอสปากกาลูกลื่นคลาสสิค แบล็ค #2502 (สัญ)",
                A3_1: "200",
                A3_2: "210",
                effective_date: "01/01/2020"
            });
        }
        return Promise.resolve(datas);
    },
    getItemsTreeview(tab_type, dataSearch) {
        var search = "/?tab=" + tab_type +
            "&keyword=" + ((dataSearch.keyword) ? dataSearch.keyword : "") +
            "&emp_code=" + ((dataSearch.emp_code) ? dataSearch.emp_code : "") +
            "&group=" + ((dataSearch.group) ? dataSearch.group : "") +
            "&sub_group=" + ((dataSearch.subGroup) ? dataSearch.subGroup : "") +
            "&cg=" + ((dataSearch.cg) ? dataSearch.cg : "") +
            "&module=bookprice";

        return axios.get('/v1/pricing/pricelist' + search)
            .then(function (response) {
                return Promise.resolve(response);
            })
            .catch(function (error) {
                // console.log(error);
                return Promise.reject(error);
            });
    },
    saveRequestPrice(datas) {
        return axios.post('/v1/bookprice/bookprice', datas)
            .then(function (response) {
                return Promise.resolve(response);
            })
            .catch(function (error) {
                return Promise.reject(error);
            });
    },
    getAllProduct(datas) {
        var type = (datas && datas.type) ? datas.type : '';
        var code = (datas && datas.code) ? datas.code : '';
        return axios.get('/v1/pricing/product-hierarchy?type=' + type + '&code=' + code + '&product_type=true')
            .then(function (response) {
                return Promise.resolve(response);
            })
            .catch(function (error) {
                return Promise.reject(error);
            });
    },
    searchProduct(code, type, dataDelete, emp_code, datas, bookprice_group, bookCode) {
        var dataSearch = {
            has_stock: true,
            pro_code: (code) ? code : '',
            type: type,
            data_delete: dataDelete,
            emp_code: emp_code,
            name: (datas.name) ? datas.name : '',
            group: (datas.group) ? datas.group : '',
            subgroup: (datas.subgroup) ? datas.subgroup : '',
            cg: (datas.cg) ? datas.cg : '',
            producttype: (datas.type) ? datas.type : '',
            page: 'bookprice',
            bookprice_group: bookprice_group,
            groupbook_code: (bookCode) ? bookCode : '',
        }
        return axios.post('/v1/pricing/search-product', dataSearch)
            .then(function (response) {
                return Promise.resolve(response);
            })
            .catch(function (error) {
                return Promise.reject(error);
            });
    },
    searchProduct2(code, type, dataDelete, emp_code, datas, bookprice_group, bookCode) {
        /* search product check status active and product cycle only */
        var dataSearch = {
            has_stock: true,
            pro_code: (code) ? code : '',
            type: type,
            data_delete: dataDelete,
            emp_code: emp_code,
            name: (datas.name) ? datas.name : '',
            group: (datas.group) ? datas.group : '',
            subgroup: (datas.subgroup) ? datas.subgroup : '',
            cg: (datas.cg) ? datas.cg : '',
            producttype: (datas.type) ? datas.type : '',
            page: 'bookprice',
            bookprice_group: bookprice_group,
            groupbook_code: (bookCode) ? bookCode : '',
        }
        return axios.post('/v1/pricing/search-product2', dataSearch)
            .then(function (response) {
                return Promise.resolve(response);
            })
            .catch(function (error) {
                return Promise.reject(error);
            });
    },
    async exportTemplate(dataSearch, datasArray) {
        let user = Vue.$jwt.decode(localStorage.getItem('token'));
        var user_db;
        await userService.getInfo(user.id)
            .then((response) => {
                // console.log("response ==>", response);
                user_db = response;
            })

        var search = "?emp_code=" + dataSearch.emp_code +
            "&effective_date=" + ((dataSearch.effective_date) ? dataSearch.effective_date : "") +
            "&expire_date=" + ((dataSearch.expire_date) ? dataSearch.expire_date : "") +
            "&user_email=" + ((user_db.email) ? user_db.email : "") +
            "&groupbook_id=" + ((dataSearch.groupbook_id) ? dataSearch.groupbook_id : "");
        datasArray.email = user_db.email;

        return axios.post('/v1/bookprice/export-price' + search, datasArray)
            .then(function (response) {
                return Promise.resolve(response);
            })
            .catch(function (error) {
                if (error.response && error.response.data) {
                    return error.response.data;
                }
                return Promise.reject(error);
            });
    },
    async exportTemplateCSV(dataSearch, datasArray) {
        //console.log('exportTemplateCSV...');
        let user = Vue.$jwt.decode(localStorage.getItem('token'));
        var user_db;
        await userService.getInfo(user.id)
            .then((response) => {
                // console.log("response ==>", response);
                user_db = response;
            })

        var search = "?emp_code=" + dataSearch.emp_code +
            "&effective_date=" + ((dataSearch.effective_date) ? dataSearch.effective_date : "") +
            "&expire_date=" + ((dataSearch.expire_date) ? dataSearch.expire_date : "") +
            "&user_email=" + ((user_db.email) ? user_db.email : "") +
            "&groupbook_id=" + ((dataSearch.groupbook_id) ? dataSearch.groupbook_id : "");
        datasArray.email = user_db.email;

        return axios.post('/v1/bookprice/export-price-csv' + search, datasArray)
            .then(function (response) {
                return Promise.resolve(response);
            })
            .catch(function (error) {
                if (error.response && error.response.data) {
                    return error.response.data;
                }
                return Promise.reject(error);
            });
    },
    compareCustomer(datas) {
        return axios.post('/v1/bookprice/compare', datas)
            .then(function (response) {
                return Promise.resolve(response);
            })
            .catch(function (error) {
                return Promise.reject(error);
            });
    },
    async checkDataDelete(emp_code = '') {
        var query = "/?emp_code=" + emp_code;
        return axios.get('/v1/bookprice/check-data-delete' + query)
            .then(function (response) {
                return Promise.resolve(response);
            })
            .catch(function (error) {
                return Promise.reject(error);
            });
    },
    deleteTemplateFile(idFile, emp_code = '') {
        return axios.post('/v1/bookprice/delete-file-template', {
                data: {
                    id: idFile,
                    emp_code: emp_code
                }
            }).then(function (response) {
                return Promise.resolve(response);
            })
            .catch(function (error) {
                return Promise.reject(error);
            });
    },
    async checkDataImport(docno = '') {
        let user = Vue.$jwt.decode(localStorage.getItem('token'));
        var user_db;
        await userService.getInfo(user.id)
            .then((response) => {
                user_db = response;
            })

        var dataImport = "/?page=bookprice&user_email=" + ((user_db.email) ? user_db.email : "") + "&docno=" + docno;
        return axios.get('/v1/bookprice/check-data-import' + dataImport)
            .then(function (response) {
                return Promise.resolve(response);
            })
            .catch(function (error) {
                // console.log(error);
                return Promise.reject(error);
            });
    },
    importBookPrice(data) {
        var dataImport = "/?id=" + ((data.id) ? data.id : "") + "&pricegroup=" + ((data.pricegroup) ? data.pricegroup : "") + "&eff_date=" + ((data.eff_date) ? data.eff_date : "");
        return axios.get('/v1/bookprice/import-price' + dataImport)
            .then(function (response) {
                return Promise.resolve(response);
            })
            .catch(function (error) {
                // console.log(error);
                return Promise.reject(error);
            });
    },
    deleteFilePriceList(idFile) {
        var fileDelete = "/?id=" + ((idFile) ? idFile : "");
        return axios.get('/v1/pricing/delete-file-pricelist' + fileDelete)
            .then(function (response) {
                return Promise.resolve(response);
            })
            .catch(function (error) {
                // console.log(error);
                return Promise.reject(error);
            });
    },
    getUserActivity(datas) {
        var emp_code = (datas && datas.emp_code) ? datas.emp_code : '';
        return axios.get('/v1/bookprice/user_activity?emp_code=' + emp_code)
            .then(function (response) {
                return Promise.resolve(response);
            })
            .catch(function (error) {
                return Promise.reject(error);
            });
    },
    getComment(datas) {
        var id = (datas && datas.id) ? datas.id : '';
        return axios.get('/v1/bookprice/comment?id=' + id)
            .then(function (response) {
                return Promise.resolve(response);
            })
            .catch(function (error) {
                // console.log(error);
                return Promise.reject(error);
            });
    },
    replyComment(datas) {
        return axios.post('/v1/bookprice/comment', datas)
            .then(function (response) {
                return Promise.resolve(response);
            })
            .catch(function (error) {
                return Promise.reject(error);
            });
    },
    getViewBookPrice(datas, type_export, cancelToken) {
        var tab = (datas && datas.tab) ? datas.tab : '';
        var keyword = (datas && datas.keyword) ? datas.keyword : '';
        var emp_code = (datas && datas.emp_code) ? datas.emp_code : '';
        var groupbook_code = (datas && datas.groupbook_code) ? datas.groupbook_code : '';
        // var customer = (datas && datas.customer) ? datas.customer : '';
        var customer_compare = (datas && datas.customer_compare) ? datas.customer_compare : '';
        var search = (datas && datas.search) ? datas.search : '';
        var type = (datas && datas.type) ? datas.type : '';
        var group = (datas && datas.group) ? datas.group : '';
        var sub_group = (datas && datas.sub_group) ? datas.sub_group : '';
        var cg = (datas && datas.cg) ? datas.cg : '';
        var type_export = (datas && datas.type_export) ? datas.type_export : '';
        var start = (datas && datas.start) ? datas.start : '';
        var limit = (datas && datas.limit) ? datas.limit : '';

        return axios.get('/v1/pricing/bookprice?tab=' + tab + '&keyword=' + keyword + '&emp_code=' + emp_code +
                '&groupbook_code=' + groupbook_code + '&customer_compare=' + customer_compare +
                '&search=' + search + '&type=' + type + '&group=' + group + '&sub_group=' + sub_group + '&cg=' + cg +
                '&m=' + type_export + '&start=' + start + '&limit=' + limit, {
                    cancelToken: cancelToken // เพิ่ม CancelToken เข้าไปใน request
            })
            .then(function (response) {
                return Promise.resolve(response);
            })
            .catch(function (error) {
                if (axios.isCancel(error)) {
                    // console.log('Request canceled:', error.message);
                }
                return Promise.reject(error);
            });
    },
    countViewBook(datas, cancelToken) {
        var code = (datas && datas.code) ? datas.code : '';
        // var type = (datas && datas.type) ? datas.type : '';
        // return axios.get('/v1/pricing/count-bookprice?group_code=' + code + '&is_customer=' + type)
        return axios.get('/v1/pricing/count-bookprice?group_code=' + code, {
                cancelToken: cancelToken // เพิ่ม CancelToken เข้าไปใน request
            })
            .then(function (response) {
                return Promise.resolve(response);
            })
            .catch(function (error) {
                // console.log(error);
                return Promise.reject(error);
            });
    },
    deleteRowBookprice(datas) {
        return axios.delete('/v1/bookprice/delete-row-bookprice', {
                data: {
                    "id": datas.id,
                    "user": datas.user
                }
            })
            .then(function (response) {
                return Promise.resolve(response)
            })
            .catch(function (error) {
                return Promise.reject(error)
            });
    },
    getShareDetail(datas) {
        return axios.get('/v1/bookprice/share-detail?id=' + datas.id + '&emp_code=' + datas.emp_code)
            .then(function (response) {
                return Promise.resolve(response);
            })
            .catch(function (error) {
                return Promise.reject(error)
            });
    },
    getShareUser() {
        return axios.get('/v1/bookprice/share-user')
            .then(function (response) {
                return Promise.resolve(response);
            })
            .catch(function (error) {
                return Promise.reject(error)
            });
    },
    sendShareTemplate(datas) {
        return axios.post('/v1/bookprice/share-file', {
                data: datas
            })
            .then(function (response) {
                return Promise.resolve(response);
            })
            .catch(function (error) {
                return Promise.reject(error);
            });
    },
    getGroupBookMaster() {
        return axios.get('/v1/bookprice/groupbook-master')
            .then(function (response) {
                return Promise.resolve(response.data);
            })
            .catch(function (error) {
                return Promise.reject(error);
            });
    },
    getBookPriceHistory(datas) {
        let emp_code = Vue.$jwt.decode(localStorage.getItem('token')).code;
        var code = (datas && datas.code) ? datas.code : '';
        var bookGroup = (datas && datas.bookGroup) ? datas.bookGroup : '';
        return axios.get('/v1/pricing/pricelog/?code=' + code + '&emp_code=' + emp_code + '&groupbook=' + bookGroup)
            .then(function (response) {
                return Promise.resolve(response);
            })
            .catch(function (error) {
                return Promise.reject(error);
            });
    },
    getBookType(datas) {
        return axios.get('/v1/bookprice/booktype')
            .then(function (response) {
                return Promise.resolve(response.data);
            })
            .catch(function (error) {
                return Promise.reject(error);
            });
    },
}